// extracted by mini-css-extract-plugin
export var banner = "_oz-0";
export var settingRow = "_oz-2";
export var titleIcon = "_oz-1";